import { render, staticRenderFns } from "./InparkserviceDetail.vue?vue&type=template&id=c97c7fb2&scoped=true"
import script from "./InparkserviceDetail.vue?vue&type=script&lang=js"
export * from "./InparkserviceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97c7fb2",
  null
  
)

export default component.exports